import { Header }
  // eslint-disable-next-line max-len
  from '@modules/proposals/presentation/v2/pages/ProposalCreation/es/views/EditableTemplate/features/template/components/Header';
import { FinancialRequirements }
  // eslint-disable-next-line max-len
  from '@modules/proposals/presentation/v2/pages/ProposalCreation/es/views/EditableTemplate/features/template/components/FinancialRequirements';
import { CitizenStatus, EmploymentStatus } from '@modules/opportunities/entities/opportunity/opportunity.entity';
import { OfferDetails } from '@modules/proposals/presentation/v2/pages/ProposalCreation/es/views/EditableTemplate/features/template/components/OfferDetails';
import { Flex } from '@huspy/briks-web';

type Props = {
  clientDetails: {
    name: string;
    employmentStatus: EmploymentStatus;
    residencyStatus: CitizenStatus;
  };
  brokerDetails: {
    name: string;
    brokerageLogo: string;
    brokeragePrimaryColor: string;
    email: string;
    phone: string;
  };
  config: {
    numberOfOffers: number;
  }
};

export const ProposalTemplate = ({ clientDetails, brokerDetails, config }: Props) => (
  <Flex direction='column'>
    <Header
      clientName={ clientDetails.name }
      brokerName={ brokerDetails.name }
      brokerLogo={ brokerDetails.brokerageLogo }
      brokerEmail={ brokerDetails.email }
      brokerPhone={ brokerDetails.phone }
    />
    <Flex direction='column' mt='12' pl='10' pr='10'>
      <FinancialRequirements
        employmentStatus={ clientDetails.employmentStatus }
        citizenStatus={ clientDetails.residencyStatus }
      />
      <OfferDetails
        numberOfOffers={ config.numberOfOffers }
      />
    </Flex>
  </Flex>
);
